import { useDropzone } from 'react-dropzone';
import { Controller } from 'react-hook-form';
import { LABELS } from '~/resources/Labels';
import { MESSAGES } from '~/resources/Message';
import {FormScriptResponse } from '~/models/Commons ';
import { UseFormScript } from './UseFormScript';
import { SIMPLInput} from '../../components/commons/input/SIMPLInput';
import { SIMPLDialog } from '../../../src/components/commons/dialog/SimplDialog';
import { SIMPLSelectDropdown } from '../../components/commons/input/SIMPLSelectDropdown';
import { SIMPLButtonCustomized } from '../../components/commons/button/SIMPLButtonCustumized';
import getInputClassFile from '~/assets/styles/classes/InputClasses';
import SIMPLFile from '../../components/commons/input/SIMPLFile';
import { useEffect, useState } from 'react';
import { extractEnvDetails } from '~/Utils/Utils';
interface Prop {
  onCloseModal: () => void;
  editedItem: FormScriptResponse | null;
  setConfig:Function
  title?:string
  refetch:()=>void
}

export const AddScript = ({ onCloseModal, editedItem,setConfig,refetch,title}: Prop) => {
  const {
    handleSubmit,
    control,
    errors,
    currentScript,
    currentConfigFiles,
    onScriptDrop,
    onConfigDrop,
    submitForm,
    cloudEnvData
  } = UseFormScript(editedItem, onCloseModal,refetch);
const [selectCloudEnv, setSelectCloudEnv] = useState<any[]>([]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop:onScriptDrop,
    maxFiles: 1,
    accept: {
      'application/x-yaml': ['.yml', '.yaml'],
      'application/json': ['.json'],
      'text/plain': ['.hcl','.tf'],
    },
  });
  
 // Second Dropzone for configFiles (accepts only YAML)
 const {getRootProps: getConfigRootProps,
  getInputProps: getConfigInputProps,
  isDragActive: isConfigDragActive } = useDropzone({
  onDrop:onConfigDrop,
  maxFiles: 1,
  accept: {
    'application/x-yaml': ['.yml', '.yaml']
  },
});
 
  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
   handleSubmit(submitForm)(event); 
   setConfig({
    key: '',
    direction: LABELS.ASC,
  })
  };

 const initVmTemplate = () => {
    const payloadEnviroment: any = cloudEnvData?.payload;
    if (payloadEnviroment) {
      setSelectCloudEnv(extractEnvDetails(payloadEnviroment.content));
    }
  }
  useEffect(()=>{initVmTemplate()},[cloudEnvData])
  const renderButtons = () => (
    <>
      <div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized label="Cancel" secondary buttonHandlerAction={onCloseModal} />
      </div>
      <div className="grow-0 basis-32">
        <SIMPLButtonCustomized label={editedItem ? LABELS.Update : LABELS.Submit} primary />
      </div>
    </>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={editedItem ? LABELS.EditScript :title!}
      actions={renderButtons()}
      onSubmit={handleFormSubmit}
    >
     <div className="flex justify-center">
  <div className="w-[500px]">
    <div className="flex flex-col w-full space-y-4"> 
      <SIMPLInput
        name="title"
        control={control}
        rules={{ required: { value: true, message: MESSAGES.MessageTitleRequired } }}
        label={LABELS.Title}
        placeholder={LABELS.Title}
        required
        id="title"
        fontWeight="bold"
        errorLabel={errors.title?.message}
      />

      <SIMPLInput
        name="description"
        control={control}
        rules={{ required: { value: true, message: MESSAGES.MessageDescriptionRequired } }}
        label={LABELS.Description}
        required
        id="description"
        fontWeight="bold"
        errorLabel={errors.description?.message}
        placeholder={LABELS.Description}
      />

       <Controller
        name="cloudEnvironmentId"
        control={control}
        rules={{ required: MESSAGES.MessageCloudEnvironmentRequired }}
        render={({ field }) => (
          <SIMPLSelectDropdown
            id="cloudEnvironmentId"
            label={LABELS.CloudEnviroment}
            options={selectCloudEnv?.map((cloudEnv:any) => ({
              label: cloudEnv.environmentName,
              value: cloudEnv.id,
            }))}
            isRequired
            value={field.value}
            onChange={field.onChange}
            hideErrorLabel
            errorLabel={errors.cloudEnvironmentId?.message as string}
            placeholder={LABELS.CloudEnviroment}
          />
        )}
      />
        <SIMPLFile
          required
          errors={errors}
          currentScript={currentScript}
          labelName={LABELS.ScriptRequired}
          LABELS={LABELS}
          getRootProps={getRootProps}
          getInputProps={getInputProps}
          getInputClassFile={getInputClassFile}
          isDragActive={isDragActive}
        />
         <SIMPLFile
          required={false}
          errorFieldName='configFiles'
          errors={errors}
          currentScript={currentConfigFiles}
          LABELS={LABELS}
          labelName={LABELS.ConfigFiles}
          getRootProps={getConfigRootProps}
          getInputProps={getConfigInputProps}
          getInputClassFile={getInputClassFile}
          isDragActive={isConfigDragActive}
        />
      </div>
    </div>
  </div>

    </SIMPLDialog>
  );
};